import styled from 'styled-components';

const MentorImage = styled.img`
  width: 45px;
  height: 45px;
  margin-bottom: 3px;
  border-radius: 50%;
  border: 1px solid #000;

  @media only screen and (max-width: 768px) {
    width: 45px;
    height: 45px;
  }

`;

export default MentorImage;
